import { computed, Ref, ref, unref } from 'vue';
import { Article, Meta } from '~/types';
import { useArticlesApi } from '~/api/articles';
import * as Sentry from '@sentry/vue';

export const useLoadArticles = (params: Ref<Article.RequestParameters>) => {
  const { search } = useArticlesApi();
  const loading = ref<boolean>(false);

  const meta = ref<Partial<Meta>>({
    current_page: 0,
  });

  const isLastPage = computed(() => meta.value.current_page === meta.value.last_page);

  const articles = ref<Article.Model[]>([]);

  const loadData = async (reset: boolean = false) => {
    if (reset) {
      articles.value = [];
      meta.value.current_page = 0;
    }
    const page = (meta.value.current_page || 0) + 1;

    if (loading.value) {
      return;
    }

    loading.value = true;
    try {
      const data = await search({ ...unref(params), page });
      articles.value.push(...data.data);
      meta.value = data.meta;
    } catch (ex) {
      Sentry.captureException(ex);
    } finally {
      loading.value = false;
    }
  };

  return { articles, loadData, loading, isLastPage };
};
